<div class="items-catalog-container">
	<!-- En-tête avec barre de recherche et bouton d'ajout -->
	<div class="catalog-header">
		<div class="search-section">
			<div class="search-container">
				<div class="search-input-wrapper">
					<i class="bi bi-search search-icon"></i>
					<input
						[(ngModel)]="searchText"
						class="search-input"
						placeholder="Rechercher un utilitaire..."
						type="text"
					/>
					@if (searchText) {
						<button class="clear-search" (click)="searchText = ''">
							<i class="bi bi-x-circle"></i>
						</button>
					}
				</div>
			</div>

			@if ((isAdmin$ | async) && !isInCharacterCreation) {
				<div class="admin-controls">
					<button class="add-item-btn" (click)="openCreateUtilitaireModal()">
						<i class="bi bi-plus-circle"></i>
						<span>Ajouter un utilitaire</span>
					</button>
				</div>
			}
		</div>
	</div>

	<!-- Section Utilitaires -->
	@if (utilitaire$ | async | filterList: searchText : filterFn; as filteredUtilitaires) {
		<div class="item-section">
			<div class="section-header">
				<h2 class="section-title">
					<i class="bi bi-tools"></i>
					Utilitaires & Outils
					<span class="item-count">({{ filteredUtilitaires.length }})</span>
				</h2>
			</div>

			<!-- Version Desktop - Table -->
			<div class="desktop-view d-none d-lg-block">
				<div class="table-wrapper">
					<table class="items-table">
						<thead>
						<tr>
							<th class="col-name">
								<i class="bi bi-tag"></i> Nom
							</th>
							<th class="col-effects">
								<i class="bi bi-magic"></i> Effets
							</th>
							<th class="col-price">
								<i class="bi bi-coin"></i> Prix
							</th>
						</tr>
						</thead>
						<tbody>
							@for (item of filteredUtilitaires; track item._id || $index) {
								<tr class="item-row">
									<td class="item-name">
										<div class="name-cell">
											<div class="item-icon utilitaire">
												<i class="bi bi-tools"></i>
											</div>
											<span class="name-text">{{ item.nom }}</span>
										</div>
									</td>
									<td class="item-effects">
										<div class="effects-text">{{ item.effet }}</div>
									</td>
									<td class="item-price">
                               <span class="price-value">
                                  <i class="bi bi-coin text-warning"></i>
								   {{ item.prix }}
                               </span>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>

			<!-- Version Mobile - Cards -->
			<div class="mobile-view d-lg-none">
				<div class="items-grid utilitaires-grid">
					@for (item of filteredUtilitaires; track item._id || $index) {
						<div class="item-card utilitaire-card">
							<div class="card-header">
								<div class="item-icon">
									<i class="bi bi-tools"></i>
								</div>
								<h5 class="item-name">{{ item.nom }}</h5>
								<span class="item-type-badge">Utilitaire</span>
							</div>
							<div class="card-body">
								<div class="item-detail">
									<i class="bi bi-magic"></i>
									<strong>Effets:</strong>
									<span>{{ item.effet }}</span>
								</div>
								<div class="item-stats-section">
									<div class="stat price-stat">
										<i class="bi bi-coin text-warning"></i>
										<span class="stat-label">Prix:</span>
										<span class="stat-value price">{{ item.prix }}</span>
									</div>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	}

	<!-- Message si aucun résultat -->
	<!--@if (searchText && !hasResults()) {
		<div class="no-results">
			<div class="no-results-content">
				<i class="bi bi-wrench"></i>
				<h3>Aucun utilitaire trouvé</h3>
				<p>Essayez avec des termes de recherche différents</p>
				<button class="btn-clear-search" (click)="searchText = ''">
					<i class="bi bi-arrow-clockwise"></i>
					Effacer la recherche
				</button>
			</div>
		</div>
	}-->
</div>
